import CustomerFreelancerLinkList from "../../slices/customer_freelancer_link/CustomerFreelancerLinkList";
import CustomerFreelancerLinkDetails from "../../slices/customer_freelancer_link/CustomerFreelancerLinkDetails";
import CustomerVendorList from "../../slices/customer_freelancer_link/CustomerVendorList";

const customerFreelancerLinkReducer = {
    customerFreelancerLinkList: CustomerFreelancerLinkList,
    customerFreelancerLinkDetails: CustomerFreelancerLinkDetails,
    customerVendorList: CustomerVendorList,
};

export default customerFreelancerLinkReducer;
